export default __webpack_public_path__ + "static/media/us.d21917ae.svg";